import styled, { css } from 'styled-components';

import { Grid } from '@/components/Grid';

import { LegacyButton } from '../LegacyButton';

export const Wrapper = styled(Grid)`
  text-align: center;
  margin: ${(props) => props.theme.spacing(2)};
  padding: 0;
`;

const PageLinkBase = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.defaultAdd5};
`;

export const PageLink = styled(PageLinkBase)<{ $isActive: boolean }>`
  ${({ $isActive, theme }) => css`
    color: ${$isActive ? theme.colors.black : theme.colors.defaultAdd5};
    font-weight: ${$isActive ? 500 : 'initial'};
  `};
`;

export const ChevronLink = styled(PageLinkBase)<{ $isDisabled: boolean }>`
  ${({ $isDisabled, theme }) => css`
    color: ${$isDisabled ? theme.colors.defaultAdd5 : theme.colors.black};
    pointer-events: ${$isDisabled ? 'none' : 'initial'};
  `};
`;

export const PaginationCTA = styled(LegacyButton)`
  ${({ theme }) => css`
    width: 100%;
    ${theme.media.md.up} {
      width: unset;
    }
  `};
`;
